import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

// Styles
import './styles.css';

const propTypes = {
  data: PropTypes.object,
};

const defaultProps = {
  data: {},
};

class StockCurrentTotalizer extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="StockCurrentTotalizer">

        <div className="StockCurrentTotalizer__box" >
          <p className="StockCurrentTotalizer__value">
            <FormattedNumber
              currencyDisplay="symbol"
              value={data.totalPallets}
              useGrouping
            />
          </p>
          <p className="StockCurrentTotalizer__measure-unit">
            Pallets
          </p>
        </div>
        <div className="StockCurrentTotalizer__box" >
          <p className="StockCurrentTotalizer__value">
            <FormattedNumber
              currencyDisplay="symbol"
              value={data.totalVolume}
              useGrouping
            /> m³
          </p>
          <p className="StockCurrentTotalizer__measure-unit">
            Volume
          </p>
        </div>
        <div className="StockCurrentTotalizer__box" >
          <p className="StockCurrentTotalizer__value">
            R$ <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              currencyDisplay="symbol"
              value={data.totalValue / 1000000}
              useGrouping
            /> MM
          </p>
          <p className="StockCurrentTotalizer__measure-unit">
            Valor
          </p>
        </div>
        <div className="StockCurrentTotalizer__box" >
          <p className="StockCurrentTotalizer__value">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              currencyDisplay="symbol"
              value={data.totalWeight / 1000}
              useGrouping
            /> t
          </p>
          <p className="StockCurrentTotalizer__measure-unit">
            Peso
          </p>
        </div>
        <div className="StockCurrentTotalizer__box" >
          <p className="StockCurrentTotalizer__value">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              currencyDisplay="symbol"
              value={data.totalQuantity / 1000000}
              useGrouping
            />
            MM
          </p>
          <p className="StockCurrentTotalizer__measure-unit">
            Unidades
          </p>
        </div>

      </div>
    );
  }
}

StockCurrentTotalizer.propTypes = propTypes;
StockCurrentTotalizer.defaultProps = defaultProps;

export default StockCurrentTotalizer;
